var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgComputer = function SvgComputer(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 21a.97.97 0 0 1-.712-.288A.97.97 0 0 1 1 20q0-.424.288-.712A.97.97 0 0 1 2 19h20q.425 0 .713.288.287.287.287.712 0 .424-.287.712A.97.97 0 0 1 22 21zm2-3q-.824 0-1.412-.587A1.93 1.93 0 0 1 2 16V5q0-.824.588-1.412A1.93 1.93 0 0 1 4 3h16q.825 0 1.413.587Q22 4.176 22 5v11q0 .824-.587 1.413A1.93 1.93 0 0 1 20 18zm0-2h16V5H4z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgComputer);
export { ForwardRef as ReactComponent };